import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
// import { CourseService } from 'src/app/services/course.service';
// import { config } from 'src/app/config';
// import { User } from 'src/app/models/user.model';
// import { Store } from 'store';
// declare var amplitude;
declare var mixpanel;

@Component({
     selector: 'app-module-completed',
     templateUrl: './module-completed.component.html',
     styleUrls: ['./module-completed.component.css']
})
export class ModuleCompletedComponent {

     user;
     @Input()
     config: {
          currModuleName: string,
          nextModuleName: string,
          nextModuleId: string
          courseTitle: string,
          nextModuleNumber: string
     };

     @Output()
     removeModuleEnd: EventEmitter<any> = new EventEmitter<any>();
     constructor(private courseService: CourseService, private store: Store) { }

     ngOnInit() {
          this.store.select<User>('user').subscribe(user => {
               if (user) {
                    this.user = user;
               }
          });
     }

     moveToNextModule() {
          /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
          amplitude.getInstance().setUserId(this.user.email);
          amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
          amplitude.getInstance().logEvent('Next Module', { 'Next Module': this.config.nextModuleName, 'Prev Module': this.config.currModuleName }); */
          // mixpanel.track("Next Module",
          // { 'Next Module': this.config.nextModuleName, 'Prev Module': this.config.currModuleName });
          this.courseService.setcurrentPlayedItem(this.config.nextModuleId);
          this.removeModuleEnd.emit({
               moduleNumber: this.config.nextModuleNumber,
               moduleName: this.config.nextModuleName
          });
     }

}
